import type { PropsWithChildren } from 'react'

type TabButtonProps = PropsWithChildren & {
  onClick: () => void
  value: string
  currentValue: string
}

export default function TabButton({
  onClick,
  children,
  value,
  currentValue,
}: TabButtonProps) {
  return (
    <button
      className={`rounded-md hover:bg-primary-100 h-9 mr-2  hover:text-primary-600 ${
        value === currentValue
          ? 'text-primary-600 bg-primary-100'
          : 'text-gray-500'
      }`}
      onClick={onClick}
    >
      <span className="px-3 font-medium text-sm">{children}</span>
    </button>
  )
}
